import { styled, css } from '@mui/system'

const shouldForwardProp = (prop) => !['variant'].includes(prop)

const listStyles = (theme) => css`
	grid-template-columns: repeat(1, calc(100% - ${theme.spacing(2)}));
	> div {
		display: flex;
		align-items: center;
		> *:last-child {
			margin-left: ${theme.spacing(1)};
		}
	}
`

export const Root = styled('div', { shouldForwardProp })`
	display: grid;
	gap: ${({ theme }) => theme.spacing(2)};
	grid-template-columns:
		${({ theme }) => `repeat(auto-fit, minmax(${theme.spacing(5)}, 1fr));`}
		${({ theme, variant }) => variant === 'list' && listStyles(theme)};
`
